
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.965 5.541a.653.653 0 00-.924.924l2.497 2.497a.653.653 0 00.924 0l2.497-2.497a.653.653 0 00-.923-.924L7 7.577 4.965 5.54z","fill":"#fff"}})])
          )
        }
      }
    